<app-generic-loading *ngIf="isLoading"></app-generic-loading>

<p-chart type="bar" *ngIf="!isLoading" [data]="data" [options]="options"></p-chart>
